document.querySelectorAll(".faq-item").forEach(el => {
    el.querySelector(".faq-q").addEventListener("click", () => {
      const wasOpen = el.classList.contains("open");
      document.querySelectorAll(".faq-item").forEach(i => i.classList.remove("open"));
      if (!wasOpen) el.classList.add("open");
    });
  });


//   Sticky bar
const stickyBar = document.getElementById("stickyBar");

if (stickyBar) {
  const SHOW_AFTER = 300; // kitne px scroll ke baad dikhe

  function toggleStickyBar() {
    if (window.scrollY > SHOW_AFTER) {
      stickyBar.classList.add("show");
    } else {
      stickyBar.classList.remove("show");
    }
  }

  window.addEventListener("scroll", toggleStickyBar, { passive: true });
  toggleStickyBar(); // page reload par sahi state set karne ke liye
}

// ---- Video testimonials: tap to play (direct MP4, no HLS needed) ----
document.querySelectorAll('.video-card').forEach(card => {
  const video = card.querySelector('video');
  const fallback = card.querySelector('.play-fallback');
  if (!video || !fallback) return;

  fallback.addEventListener('click', () => {
    video.play();
    fallback.style.display = 'none';
  });
});

// ---- Testimonial carousel ----
document.querySelectorAll('.carousel-wrap').forEach(wrap => {
  const carousel = wrap.querySelector('.testi-carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.testi-slide');
  const dotsWrap = wrap.querySelector('.car-dots');
  const prevBtn = wrap.querySelector('.car-prev');
  const nextBtn = wrap.querySelector('.car-next');

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    slides.forEach((s, i) => {
      const d = document.createElement('div');
      d.className = 'car-dot' + (i === 0 ? ' active' : '');
      d.addEventListener('click', () => {
        carousel.scrollTo({
          left: s.offsetLeft - carousel.offsetLeft,
          behavior: 'smooth'
        });
      });
      dotsWrap.appendChild(d);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
    });
  }

  carousel.addEventListener('scroll', () => {
    const idx = Math.round(carousel.scrollLeft / carousel.clientWidth);
    wrap.querySelectorAll('.car-dot').forEach((d, i) => {
      d.classList.toggle('active', i === idx);
    });
  });
});


